import utils from 'components/utilsComponent';
import saveUtmCookiesFromUrl from 'components/utm-cookies';
import metrikaCollector, {installYandexReachGoalConsoleLog} from 'components/metrika';
import {scheduleMetrikaHealthProbe} from 'components/metrika/health-probe';
import { dataLazyLoad, parents } from 'methods/utils';
import Subscribe from 'components/subscribe';
import AuthorizationModals from 'components/authorization/modals';
import Recommendation from 'components/rr-recommendation';
import Hint from 'components/hint';
import SelectionsTabSlider from 'components/selections-tab-slider';
import SelectionsTabTile from 'components/selections-tab-tile';
import Header, {initHeaderBookingFromCookie} from 'components/header';
import AuthorizationModal from 'components/authorization-modal';
import CookiesConsent from 'components/cookies-consent';
import ListViewedHotels from 'components/list-viewed-hotels';
import TouristLeadsWidget from 'components/tourist-leads/widget';
import {initBookingUnpaidPopupFromAjax} from 'components/booking-unpaid-popup';
import {initSupportBannerMetrika, initSupportMaxButtonFromAjax} from 'components/support-max-button';
import initThemeToggle from 'components/theme-toggle';
import initThemeMetrika from 'components/theme-metrika';
// import 'vendor/cg-metrika'; // отключено 2024-02-07

installYandexReachGoalConsoleLog();

saveUtmCookiesFromUrl();
initHeaderBookingFromCookie();
initThemeToggle();
initThemeMetrika();

window.metrikaCollector = metrikaCollector;
scheduleMetrikaHealthProbe(metrikaCollector);

let $touristLeads = document.querySelector('.js-tourist-leads-widget');
if ($touristLeads && window.enable_tourist_lead_widget) {
    new TouristLeadsWidget($touristLeads);
}

initBookingUnpaidPopupFromAjax();
initSupportBannerMetrika();
initSupportMaxButtonFromAjax();

document.querySelectorAll('.js-selections-tab-slider').forEach($item => {
    $item.selectionsTabSlider = new SelectionsTabSlider($item);
});

document.querySelectorAll('.js-selections-tab-tile').forEach($item => {
    $item.selectionsTileTab = new SelectionsTabTile($item);
});

// тултипы
Hint.init();

// Отметка просмотренных объектов
new ListViewedHotels();

// модалка авторизации
const authModal = new AuthorizationModal({
    disableClose: true,
});

document.addEventListener('click', e => {
    if (e.target.closest('.js-authorization-modal-open')) {
        authModal.auth().then((auth) => {
            if (auth.type == 'tourist') {
                window.location.href = '/lk/booking/';
            } else if (auth.type == 'hotel') {
                window.location.href = '//panel.privettur.ru';
            } else {
                throw new Error(`Action is not defined for "${auth.type}" authentification`);
            }
        });
    }
});

// формы подписки
document.querySelectorAll('.Subscribe').forEach(($element) => {
    new Subscribe($element);
});

// плашка согласия на использование куки
new CookiesConsent(document.querySelector('.CookiesConsent'));

// время генерации страницы
utils.pageGenerateTime();

// ставим точки для опций отелей
utils.jsDots(document.querySelectorAll('.js-formFilterModal').length);

/**
 * Обработчик открытия пользовательских ссылок
 */
utils.addTrigger('click mousedown', '.js-link', function() {
    return utils.jsLink(this.dataset.href, this.dataset.target);
});

/**
 * Обработчик открытия ссылок отелей
 */
utils.addTrigger('click', '.js-hotelLink', function() {
    const href = this.href || this.dataset.href || undefined;
    if (href === undefined) return true;

    // fix slick стрелок
    if (this.classList.contains('js-arrowPrev') || this.classList.contains('js-arrowNext')) {
        return true;
    }

    return utils.jsLink(href, '_blank');
});

/**
 * Кнопка наверх
 */
utils.activateScrollUpButton();

/**
 * Показываем tooltip
 */
utils.addTrigger('click', '.js-object-sticker', function(e) {
    e.stopPropagation();

    document.querySelectorAll('.js-object-sticker').forEach($sticker => {
        $sticker.classList.remove('is-visible');
    });

    this.classList.add('is-visble');
});

/**
 * Отмечаем избранное
 */
utils.checkFavoriteList();

/**
 * Переключение избранного
 */
utils.addTrigger('click', '.js-objectFavorite, .js-objectFavoriteHotel', function(e) {
    e.preventDefault();
    e.stopPropagation();

    const $button = this;
    const id = +$button.dataset.id || 0;
    let favorite_list = utils.getCookie('favorite_list');
    //const counter_elem = $('.Header__favorite');
    favorite_list = typeof favorite_list === 'undefined' ? [] : JSON.parse(favorite_list);
    const index = favorite_list.indexOf(id);

    // элемент в массиве - удаляем
    if (index > -1) {
        favorite_list.splice(index, 1);
    }

    // переключаем избранное
    const $icons = $button.querySelectorAll('svg');

    if ($icons.length > 1) {
        const $icon = $icons[1];
    
        $icon.style.display = 'block';
        if ($icon.classList.contains('fade-out')) {
            $icon.classList.replace('fade-out', 'fade-in');
            setTimeout(() => $icon.classList.replace('fade-in', 'fade-in-reduce'), 400);
        } else if ($icon.classList.contains('fade-in-reduce')) {
            $icon.classList.replace('fade-in-reduce', 'fade-out');
        } else {
            $icon.classList.add('fade-out');
        }
    }

    $button.classList.toggle('active');
    if($button.classList.contains('active')) {
        favorite_list.push(id);
    }

    // меняем текст на кнопке в карточке объекта
    if ($button.classList.contains('js-objectFavoriteHotel') && !$button.classList.contains('js-mobile')) {
        if ($button.classList.contains('active')) {
            $button.textContent = 'Сохранено';
        } else {
            $button.textContent = 'Сохранить';
        }
    }

    // сохраняем
    utils.setCookie('favorite_list', JSON.stringify(favorite_list), 365);

    // обновляем счётчик избранного
    utils.updateFavorites(favorite_list.length);
});

/**
 * Инициализация обсерверов
 */
utils.initObserver();

/**
 * Инициализация style-fixer
 */
utils.initFallbackStyles();

/**
 * Ставим обсерверы на просмотры объектов
 */
utils.updateHotelViewObserver();

/**
 * Скрипт анимации прелоадера - логотипа
 */
utils.animateSvgPre();

/**
 * Серверный редирект
 */
utils.addTrigger('submit', '.js-hotelRedirect, .js-postRedirect', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    let $form = this;
    let url = $form.action;

    // старый вид редиректа
    if (url.indexOf('redirect') === -1) {
        window.location.href = url;
        return;
    }

    fetch(url, {
        method: $form.method,
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        },
        cache: "no-store",
    }).then((response) => {
        const rLocation = response.headers.get('x-location');
        const rTarget   = response.headers.get('x-target');
        
        if (rLocation) {
            if (rTarget === '_blank') {
                window.open(rLocation, '_blank');
            } else if (url.indexOf('hotel') == -1 && url.indexOf('link') == -1) {
                window.location.href = rLocation;
            } else {
                window.open(rLocation, '_self');
            }
        }
    });
});

dataLazyLoad();

new Recommendation();
new AuthorizationModals();

setTimeout(() => {
    if (!Header.prototype.isInit()) {
        new Header();
    }
}, 1500);

function lazyLoadValues() {
    document.querySelectorAll('.js-lazyValue').forEach($item => {
        $item.innerText = $item.dataset.lazyValue;
        $item.removeAttribute('data-lazy-value');
        $item.classList.remove('js-lazyValue');
    });
}

setInterval(lazyLoadValues, 1500);

utils.subscribeEvent('lazy_block', (data) => {
    let $tab = parents(data.$parent, '.js-selections-tab-slider')[0];

    if ($tab) {
        $tab.selectionsTabSlider.initTabSlider();
        lazyLoadValues();
    }
});
